import { useState } from 'react';
import { getLang } from '../../../Helpers/functions';
import style from '../PaymentStatusScreen.module.css';
import LearnMoreModal from './LearnMoreModal';

interface WidgetProps {
    widget : any
}
const AddonsList = ({widget} : WidgetProps) => {
    const [open,setOpen] = useState(false);
    
    const openPopUp = () => {
        setOpen(!open);
    }

    const handleAddonSelection = (item : any) => {
        if(item.button.payload.url){
            window.location.href = item.button.payload.url;
        }
    }

    return <div className="card border-0 shadow-sm mt-3 position-relative">
        <div className="card-body " >
            <div className='d-flex justify-content-between align-items-center'>
                <strong style={{fontSize: "16px"}}>{widget.header}</strong>
                <img onClick={openPopUp} className={` bottom-0 ${getLang() == 'ar' ? 'start-0' : 'end-0'}`} height="25" src={widget.iconAction.icon.replace("{platform}","android").replace("{size}","h")}/>
            </div>
            <ul className='mt-4 p-0' style={{[getLang() === 'ar' ? 'marginRight' : 'marginLeft'] : "18px"}}>
                {widget.addonsList && widget.addonsList.map((item: any, index : number) => {
                    return <li className='d-flex justify-content-between align-items-center p-2 mt-2 position-relative' key={index} style={{border : `1px solid ${item.borderColor}`,borderRadius : "8px"}}>
                        <div className='d-flex align-items-center gap-2 position-absolute' style={{ [getLang() === 'ar' ? 'right' : 'left']: [getLang() === 'ar' ? '-25px' : '-30px'] }}>
                            <img className={``} height="44" src={item.image.replace("{platform}","android").replace("{size}","h")}/>
                            <div className='' style={{lineHeight : "15px"}}>
                                <strong className="d-block" style={{fontSize: "15px"}}>{item.title}</strong>
                                <span style={{fontSize : "10px"}}>{item.duration}</span>
                            </div>
                        </div>
                        <button onClick={() => {handleAddonSelection(item)}} className={`btn fw-bold ${getLang() == 'ar' ? 'me-auto' : 'ms-auto'}`} style={{backgroundColor : item.button.background,fontSize : "13px",color : item.button.textColor}}>
                            {item.button.text}
                        </button>
                    </li>
                })}
            </ul>
        </div>
        <LearnMoreModal open={open} handleClose={openPopUp} link={widget.iconAction.url}/>
    </div>
}

export default AddonsList;